import { Directive, inject, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appTaskStepAnchor]'
})
export class TaskStepAnchorDirective {
  public readonly viewContainerRef = inject(ViewContainerRef);
}
